import { Icon_ShaprLogo, Icon_ShaprLogoTextSmall } from "@shapr3d/frontend-lib";
import classNames from "classnames";
import { Link } from "react-router-dom";

import useAccount from "../../../../hooks/useAccount";
import { useTracker } from "../../../../hooks/useTracker";

import style from "./LogoHeader.module.css";

interface LogoHeaderParams {
  teamId?: string;
}

export const LogoHeader = ({ teamId }: LogoHeaderParams) => {
  const { data: accountData } = useAccount();
  const tracker = useTracker();

  const shouldGoToDashboard = accountData?.teams.find(({ id }) => teamId === id);
  const redirectPath = shouldGoToDashboard
    ? `/teams/${teamId}/review-links`
    : "https://www.shapr3d.com";
  const trackLogoClick = () =>
    tracker.trackButtonClick({
      elementId: "shapr-logo-redirect",
      details: shouldGoToDashboard ? "go_to_web_dashboard" : "redirect",
    });

  return (
    <>
      <Link to={redirectPath} onClick={trackLogoClick} className={classNames(style.mobileLogo)}>
        <Icon_ShaprLogo title="Shapr3D logo" role="img" />
      </Link>
      <Link to={redirectPath} onClick={trackLogoClick} className={style.desktopLogo}>
        <Icon_ShaprLogoTextSmall title="Shapr3D logo" role="img" />
      </Link>
    </>
  );
};
